const GameStatus = {};

GameStatus.READY = 0;
GameStatus.RUNNING = 1;
GameStatus.PUZZLE_FAILED = 2;
GameStatus.PUZZLE_COMPLETED = 3;
GameStatus.TIMEOUT = 4;
GameStatus.FINISHED = 5;
GameStatus.TUTORIAL = 9;

export default GameStatus;